'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _adapters = require('../adapters');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    id: 'il.co.creditguard',

    form: [{ type: 'string', name: 'user' }, { type: 'string', name: 'password' }, { type: 'string', name: 'terminalNumber' }, { type: 'string', name: 'supplierNumber' }, { type: 'string', name: 'idPrefix' }],

    countries: ['IL'],

    fields: [],

    formValuesToMerchant: _adapters.simpleFormValuesToMerchant,
    merchantToFormValues: _adapters.simpleMerchantToFormValues,
    keyToMerchant: JSON.parse,
    merchantToKey: _stringify2.default,

    ranking: 2
};